import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { NoteModel } from "../models/notes.models";

@autoinject
export class NotesApi {

    private notesApiUrl: string = `${this.configService.config.urls.dueDiligenceApiUrl}/api/v1/Notes`;

    constructor(private configService: ConfigService, private requestClient: RequestClientService) { }
    
    //Get notes
    public getNotes(entityId: number, entityTypeId: number): Promise<NoteModel[]> {
        return this.requestClient.get(`${this.notesApiUrl}/GetComments/${entityId}/${entityTypeId}`, {});
    }

    //Add note
    public addNote(entityId: number, entityTypeId: number, comment: string, isPrivate: boolean): Promise<void> {
        return this.requestClient.post(`${this.notesApiUrl}/AddComment`, {}, { entityId: entityId, entityTypeId: entityTypeId, comment: comment, isPrivate: isPrivate });
    }

    //Delete note
    public deleteNote(commentId: number): Promise<void> {
        return this.requestClient.post(`${this.notesApiUrl}/DeleteComment`, {}, { commentId: commentId });
    }
}